import React, { useState, useEffect } from 'react'
import HeaderSecond from '../HeaderSecond';
import { ToastContainer } from 'react-toastify';
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import BreadcrumbBg from '../img/banner/breadcrumb-bg.jpg';
import axios from '../axios'
import Pagination from '../Components/Pagination'
import LoaderImg from '../img/logo/running.gif';

const EventDashboardPaymentHistory = () => {
    const navigate = useNavigate();
    // const { EventId } = useParams();

    const location = useLocation();
    const { state } = location;
    // const EventName = state ? state.event_name : ''; // localStorage.getItem("EventName")
    const [EventId, setEventId] = useState(0);
    const [EventName, setEventName] = useState("");
    useEffect(() => {
        // Only set it once if location.state exists
        if (location.state && !EventId) {
            setEventId(location.state.eventId);
            setEventName(location.state.event_name);
        }else if(!location.state && EventId === 0){
            navigate("/");
        }
    }, [location.state]);
    // console.log(state);

    const [PaymentData, setPaymentData] = useState([])
    const [ApiCall, setApiCall] = useState(false);
    const [UserData, setUserData] = useState([]);
    const [Loader, setLoader] = useState(false);

    const [SearchUser, setSearchUser] = useState("");
    const [Email, setEmail] = useState("");
    const [FromDate, setFromDate] = useState("");
    const [ToDate, setToDate] = useState("");
    const [TransactionStatus, setTransactionStatus] = useState("");
    const [TransactionID, setTransactionID] = useState("");

    var url = new URL(window.location.href);
    // console.log(url);
    const page = url.searchParams.get('PageNo') || 1
    const limit = url.searchParams.get('Limit') || 30
    const [TotalRecord, setTotalRecord] = useState("");

    const handleBackToHome = () => {
        const CountryCode = localStorage.getItem('CountryCode');
        const CountryName = localStorage.getItem('Country');
        navigate('/' + CountryCode + '/' + CountryName);
    }

    useEffect(() => {
        if ((ApiCall || page) && EventId !== 0) {
            setLoader(true);
            axios.post("get_payment_log", {
                "event_id": EventId,
                "limit": limit,
                "page": page,
                "user_name": SearchUser,
                "email": Email,
                "TransactionID": TransactionID,
                "TransactionStatus": TransactionStatus,
                "from_date": FromDate,
                "to_date": ToDate,
            })
                .then((response) => {
                    // console.log(response)
                    if (response.status === 200) {
                        setPaymentData(response.data.data.PaymentData);
                        setTotalRecord(response.data.data.TotalRecord)
                        setApiCall(false);
                        setLoader(false);
                    }
                    setApiCall(false)
                })
                .catch((error) => {
                    console.log(error);
                    setLoader(false);
                })
        }
        
    }, [EventId, SearchUser, Email, TransactionID, TransactionStatus, FromDate, ToDate, ApiCall, page])

    const HandleClear = (e) => {
        e.preventDefault();
        setFromDate(''); setToDate(''); setEmail(''); setTransactionStatus(''); setTransactionID(''); 
        setSearchUser(''); 
        navigate('/payment_history', { state: { eventId: EventId, event_name: EventName } })
    }


    return (
        <>
            {Loader ? <div><div id='loader' style={{ backgroundImage: `url(${LoaderImg})` }}></div></div> : null}
            <ToastContainer theme="colored" />
            <HeaderSecond />
            <main className="main__content_wrapper">
                <section className="breadcrumb__section breadcrumb__bg" style={{ backgroundImage: `url(${BreadcrumbBg})` }} >
                    <div className="container">
                        <div className="row row-cols-1">
                            <div className="col">
                                <div className="breadcrumb__content">
                                    <h1 className="breadcrumb__content--title text-white mb-10">
                                        {EventName}
                                    </h1>
                                    {/* <ul className="breadcrumb__content--menu d-flex">
                                        <li className="breadcrumb__content--menu__items">
                                            <div className="text-white" onClick={(e) => handleBackToHome(e)}>
                                                Home
                                            </div>
                                        </li>
                                        <li className="breadcrumb__content--menu__items">
                                            <span className="text-white">My Event</span>
                                        </li>
                                        <li className="breadcrumb__content--menu__items">
                                            <span className="text-white">{EventName}</span>
                                        </li>
                                    </ul> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div className='section--padding  pt-5'>
                    <div className='container'>
                        <div className="section__header checkout__section--header d-flex align-items-center justify-content-between mb-4">
                            <h2 className="section__header--title h3">Payment Log</h2>
                            <div className="event-visibility hand_cursor" onClick={(e) => { navigate('/event_dashboard', { state: {eventId: EventId, event_name: EventName } }); }}>
                                <div className="visibility gap-1 ">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        height={20}
                                        viewBox="0 -960 960 960"
                                        width={20}
                                    >
                                        <path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z" />
                                    </svg>
                                    Back
                                </div>
                            </div>
                        </div>

                        <div className='dashboard-card border-radius-10 mb-3 p-4'>
                            <div className="row my-2">
                                <div className="col-sm-6 d-flex align-items-center gap-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z" /></svg>
                                    <p className='h4'>Search Filter</p>
                                </div>

                                <div className="col-sm-6 d-flex align-items-center justify-content-end gap-2">
                                    <div>
                                        {
                                            (SearchUser !== "" || TransactionStatus !== "" || FromDate !== "" || ToDate !== "" || TransactionID !== "" || Email !== "") ?
                                                <p className="account__login--btn secondary__btn" onClick={(e) => {
                                                    HandleClear(e);
                                                }} style={{cursor: 'pointer'}}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M440-122q-121-15-200.5-105.5T160-440q0-66 26-126.5T260-672l57 57q-38 34-57.5 79T240-440q0 88 56 155.5T440-202v80Zm80 0v-80q87-16 143.5-83T720-440q0-100-70-170t-170-70h-3l44 44-56 56-140-140 140-140 56 56-44 44h3q134 0 227 93t93 227q0 121-79.5 211.5T520-122Z" /></svg> Clear</p>

                                                : null
                                        }
                                    </div>
                                </div>
                            </div>

                            <div className='row my-2 align-items-center'>

                                 <div className='col-sm-3'>
                                    <div className="form-floating">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder=""
                                            value={SearchUser}
                                            onChange={(e) => {
                                                setSearchUser(e.target.value); setApiCall(true);
                                            }}
                                        />
                                        <label>User Name </label>
                                    </div>
                                </div>
                             
                                <div className='col-sm-3'>
                                    <div className="form-floating">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder=""
                                            value={Email}
                                            onChange={(e) => {
                                                setEmail(e.target.value); setApiCall(true);
                                            }}
                                        />
                                        <label>Email </label>
                                    </div>
                                </div>

                                <div className='col-sm-3 my-2'>
                                    <div className="form-floating">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder=""
                                            value={TransactionID}
                                            onChange={(e) => {
                                                setTransactionID(e.target.value); setApiCall(true);
                                            }}
                                        />
                                        <label>Transaction ID</label>
                                    </div>
                                </div>

                                <div className='col-sm-3 my-2'>
                                    <div className="form-floating">
                                        <select className="form-control" name="category" value={TransactionStatus} onChange={(e) => { setTransactionStatus(e.target.value); setApiCall(true); }}>
                                            <option value="">-- Select Transaction Status --</option>
                                            <option value="1">Success</option>
                                            <option value="3">Free</option>
                                            <option value="2">Failure</option>
                                            <option value="101">In Process</option>
                                            {/* <option value="102">Success/Free</option> */}
                                        </select>
                                        <label>Transaction Status <span className="checkout__input--label__star">*</span></label>
                                    </div>
                                </div>

                                <div className='col-sm-3 my-2'>
                                    <div className="form-floating">
                                        <input
                                            className="form-control"
                                            type="date"
                                            name="event-date"
                                            value={FromDate}
                                            onChange={(e) => {
                                                setFromDate(e.target.value);
                                                setApiCall(true);
                                            }}

                                        />
                                        <label className="select-label">Date From </label>
                                    </div>
                                </div>
                                <div className='col-sm-3 my-2'>
                                    <div className="form-floating">
                                        <input
                                            className="form-control"
                                            type="date"
                                            name="event-date"
                                            value={ToDate}
                                            onChange={(e) => {
                                                setToDate(e.target.value);
                                                setApiCall(true);
                                            }}
                                        />
                                        <label className="select-label">Date To </label>
                                    </div>
                                </div> 

                                {/* <div className='col-sm-2'>
                                    {PaymentData && PaymentData.length > 0 ?
                                        // onClick={onDownload}
                                        <a href={AttendeeDetailsExcel} title='Download' download >
                                            <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M260-160q-91 0-155.5-63T40-377q0-78 47-139t123-78q17-72 85-137t145-65q33 0 56.5 23.5T520-716v242l64-62 56 56-160 160-160-160 56-56 64 62v-242q-76 14-118 73.5T280-520h-20q-58 0-99 41t-41 99q0 58 41 99t99 41h480q42 0 71-29t29-71q0-42-29-71t-71-29h-60v-80q0-48-22-89.5T600-680v-93q74 35 117 103.5T760-520q69 8 114.5 59.5T920-340q0 75-52.5 127.5T740-160H260Zm220-358Z" /></svg>
                                        </a>

                                        : ''}
                                </div> */}
                            </div>
                        </div>

                        <div className='dashboard-card p-4 border-radius-10 '>
                            {/* <button onClick={onDownload}> Export excel </button> */}
                            <div className='row'>
                                <div className='col-sm-12'>
                                    <table className="table table-hover table-responsive">
                                        {
                                            PaymentData && PaymentData.length > 0 ?
                                                <>
                                                    <thead className="thead-dark">
                                                        <tr>
                                                            <th className='text-nowrap' scope="col">Sr. No.</th>
                                                            <th className='text-nowrap' scope="col">User Name</th>
                                                            <th className='text-nowrap' scope="col">Email</th>
                                                            <th className='text-nowrap' scope="col">Mobile</th>
                                                            <th className='text-nowrap' scope="col">Transaction ID</th>
                                                            <th className='text-nowrap' scope="col">Ticket Amount</th>
                                                            <th className='text-nowrap' scope="col">Ticket Count</th>
                                                            <th className='text-nowrap' scope="col">Total Amount</th>
                                                            <th className='text-nowrap' scope="col">Payment Date</th>
                                                            <th className='text-nowrap' scope="col">Transaction Status</th>
                                                            <th className='text-nowrap' scope="col">Ticket Name</th>
                                                            
                                                            <th className='text-nowrap' scope="col">Transaction Type</th>
                                                            <th className='text-nowrap' scope="col">Taxes Status</th>
                                                            <th className='text-nowrap' scope="col">Payu Id</th>
                                                            <th className='text-nowrap' scope="col">Registration Ids</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {PaymentData.map((pmt, index) => {
                                                            const no = page !== 1 ? ((page * limit - limit) + parseFloat(index+1)) : index + 1;   
                                                            return (
                                                                <tr key={index}>
                                                                    <th scope="row" className=' text-center text-nowrap'>{no}</th>
                                                                    <td className='text-nowrap'>{pmt.firstname !== "null" ? pmt.firstname : ""}{" "}{pmt.lastname !== "null" ? pmt.lastname : ""}</td>
                                                                    <td className='text-nowrap'>{pmt.email}</td>
                                                                    <td className='text-nowrap'>{pmt.mobile}</td>
                                                                    <td className='text-nowrap'>{pmt.txnid}</td>
                                                                    <td className='text-center'>₹{parseFloat(pmt.ticket_amount).toFixed(2)}</td>
                                                                    <td className='text-nowrap'>{pmt.TotalTickets}</td>
                                                                    <td className='text-center'>₹{parseFloat(pmt.amount).toFixed(2)}</td>
                                                                    <td className='text-nowrap'>{pmt.created_datetime}</td>
                                                                    <td className='text-nowrap'>{pmt.payment_status !== "" ? pmt.payment_status.charAt(0).toUpperCase() + pmt.payment_status.slice(1) : ""}</td>
                                                                    <td className='text-nowrap'>{pmt.ticket_names}</td>
                                                                   
                                                                    <td className='text-nowrap'>{pmt.transaction_type}</td>
                                                                    <td className='text-nowrap'>{pmt.taxes_status}</td>
                                                                    <td className='text-nowrap'>{pmt.payu_id}</td>
                                                                    <td className='text-nowrap'>
                                                                        {pmt.registration_ids
                                                                            ?.split(',')
                                                                            .map((id, index) => (
                                                                            <div key={index}>
                                                                                {id.trim()}
                                                                            </div>
                                                                        ))}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </>
                                                :
                                                <>
                                                    <p>No registered users found</p>
                                                </>
                                        }
                                    </table>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-sm-12'>
                                
                                {
                                    TotalRecord > 0 ?
                                    <Pagination
                                        records={PaymentData.length}
                                        link={"payment_history"}
                                        SelectedPage={page}
                                        search={"&event_id=" + EventId}
                                        NoOfRecords={TotalRecord}
                                    /> : null
                                }

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </main>
        </>
    )
}

export default EventDashboardPaymentHistory